module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "campaign-creative"
  }, [_c('div', {
    staticClass: "campaign-creative-content"
  }, [_c('creative-preview-scaled', {
    attrs: {
      "creative": _vm.creative,
      "facebookPage": _vm.facebookPage,
      "disabledButtons": _vm.disabledButtons,
      "mobilePreview": _vm.mobilePreview,
      "enableFormPreview": _vm.enableFormPreview
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c9052b6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rabbit/campaign-creatives/creative/Creative.vue
// module id = 2012
// module chunks = 1